import { pageTitles } from '../constants/page-titles';
export var generatePageTitle = function (currentRouteName) {
    return pageTitles[currentRouteName];
};
